import { Fragment } from 'react'
import { useTranslation } from 'next-i18next'

import ArticlesList from '~/shared/components/Articles/ArticlesList/ArticlesList'
import { ArticleListItem } from '~/shared/components/Articles/ArticlesList/ArticlesList.types'
import ResponsiveImage from '~/components/Image/ResponsiveImage'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '181px' }]

export default function TutorOnDemandBlog({ articles }: { articles: ArticleListItem[] }): React.ReactElement {
  const { t } = useTranslation(['blog'])

  return (
    <Fragment>
      <section className="relative isolate w-full h-full max-w-4xl mx-auto space-x-16 flex text-black-light">
        <div className="relative z-20 max-w-2xl w-full lg:max-w-none mx-auto">
          <h1 className="mb-4 text-h3 font-semibold">{t('blog:title')}</h1>
          <ArticlesList articles={articles} className="mt-8" />
        </div>
      </section>

      <div className="fixed top-0 left-1/2 max-w-7xl w-full h-full transform -translate-x-1/2 pointer-events-none">
        <ResponsiveImage
          alt="House of Math decoration"
          height={259}
          imageClassName="hidden xl:block fixed -bottom-10 right-0 2xl:-right-4"
          imageWidths="181"
          mediaQuery={mediaQuery}
          srcKey="mentor-on-demand/home/help/beanstalk-question-mark.png"
          width={181}
        />
      </div>
    </Fragment>
  )
}
